import * as z from 'zod';

export const invoiceQueryLinkerSchema = z.object({
  id: z.number(),
  invoice_number: z.string().nullable(),
});

export type InvoiceQueryLinkerSchema = z.infer<typeof invoiceQueryLinkerSchema>;
